export default __webpack_public_path__ + "static/media/CNo.86-8.03c378a8.jpg";